/**=========================================================
 * Module: helpers.js
 * Provides helper functions for routes definition
 =========================================================*/

App.provider('RouteHelpers', ['APP_REQUIRES', function (appRequires) {
  // Set here the base of the relative path
  // for all app views
  this.basepath = uri => `app/views/${uri}`

  // Generates a resolve object by passing script names
  // previously configured in constant.APP_REQUIRES
  this.resolveFor = function () {
    const _args = Array.prototype.slice.call(arguments)
    return {
      deps: ['$ocLazyLoad','$q', ($ocLL, $q) => {
        // Every argument is an independent requirement, so load them all in
        // parallel instead of chaining one round trip after another. Ordering
        // *inside* a requirement (e.g. a plugin after its library) is expressed
        // with `serie: true` on the APP_REQUIRES entry, not by argument order.
        return $q.all(_args.map(_arg => {
          // also support a function that returns a promise
          if(typeof _arg == 'function') return $q.when().then(_arg)
          // if is a module, pass the config. If not, pass the array of files
          const whatToLoad = getRequired(_arg)
          if(!whatToLoad) return $q.reject(new Error(`Route resolve: Bad resource name [${_arg}]`))
          return $ocLL.load(whatToLoad)
        }))

        // check and returns required data
        // analyze module items with the form [name: '', files: []]
        // (matched by `key` when present, otherwise by `name`)
        // and also simple array of script files (for not angular js)
        function getRequired(name) {
          if (appRequires.modules)
              for(var m in appRequires.modules)
                  if((appRequires.modules[m].key || appRequires.modules[m].name) === name)
                      return appRequires.modules[m]
          return appRequires.scripts && appRequires.scripts[name]
        }

      }]}
  }; // resolveFor

  // not necessary, only used in config block for routes
  this.$get = () => {}
}])

